import { IPodsModuleFields } from 'contentful/types/contentful-modules'
import { MappingContext } from '@/components/content/contentMapper'
import { PodsModuleItems } from '@/components/pods-module/pods.module'

interface PodDatalayer {
  event_name: string
  event_type: string
  offer_id: string
  offer_name: string
  offer_component: string
  offer_slot: string
  offer_image_name: string
  offer_image_url: string
  offer_cta: string
  offer_link: string
}

export const podsModuleDatalayer = (items: PodsModuleItems[]): PodDatalayer[] =>
  items?.map(
    ({ title, image, link, id, indexOnPage, buttonText, imageName }) => ({
      event_name: 'offer-impression',
      event_type: 'link',
      offer_id: id,
      offer_name: title,
      offer_component: 'marketing pods',
      offer_slot: indexOnPage,
      offer_image_name: imageName || '',
      offer_image_url: image || '',
      offer_cta: buttonText || '',
      offer_link: link?.href || '',
    }),
  )

export const getPodsModuleCounter = (
  context: MappingContext,
  id: string,
): { numberOnPage: number } => {
  let numberOnPage = 0

  const podsModuleCounter = context.content?.content?.reduce(
    (acc, { sys, fields }) => {
      if (sys?.contentType?.sys?.id === 'pods.module' && Boolean(fields?.id)) {
        acc[fields?.id] = {
          numberOnPage,
        }
        numberOnPage += (fields as IPodsModuleFields).pods?.length
      }
      return acc
    },
    {} as Record<string, { numberOnPage: number }>,
  )

  return podsModuleCounter?.[id] || { numberOnPage: 0 }
}
